/* Accounts route paths. Use these as hrefLink values in the getMenu document. */

module.exports = Object.freeze({
  LEDGER_LIST: "/accounts/ledgers",
  LEDGER_CREATE: "/accounts/ledgers/new",
  LEDGER_EDIT: "/accounts/ledgers/edit",
  SALES_CREATE: "/accounts/sales/new",
  PURCHASE_CREATE: "/accounts/purchases/new",
  RECEIPT_CREATE: "/accounts/receipts/new",
  PAYMENT_CREATE: "/accounts/payments/new",
  VOUCHER_LIST: "/accounts/vouchers",
  VOUCHER_VIEW: "/accounts/vouchers/view",
  CHEQUES: "/accounts/cheques",
  REPORTS: "/accounts/reports",
  LEDGER_STATEMENT: "/accounts/reports/ledger-statement",
  DAY_BOOK: "/accounts/reports/day-book",
  OUTSTANDING: "/accounts/reports/outstanding",
  customerOutstanding: (id) => `/accounts/reports/outstanding/${id}`,
  AGING: "/accounts/reports/aging",
  PAYABLES: "/accounts/reports/payables",
  CUSTOMERS: "/accounts/customers",
  SALES_ORDERS: "/accounts/sales/orders",
  LOADING_ADVICES: "/accounts/sales/loading-advices",
  SALES_INVOICES: "/accounts/sales/invoices",
  CREDIT_NOTE: "/accounts/vouchers/credit-note",
  DEBIT_NOTE: "/accounts/vouchers/debit-note",
  JOURNAL: "/accounts/vouchers/journal",
  PORTAL: "/accounts/portal",
});
